import { businessKey } from 'queryKeys';

const KPI = 'kpi';
const ANNOTATIONS = 'annotations';

const kpiQuery = businessKey.query(KPI);
export const grids = kpiQuery.grids();
export const grid = kpiQuery.grid();
export const chart = kpiQuery.chart();
export const annotations = kpiQuery.exact(ANNOTATIONS);
